import React from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';

import CmtVertical from '../../../../../@coremat/CmtNavigation/Vertical';
import SidebarButtons from './SIdebarButtons';
import { sidebarNavs } from '../menus';
import { useSelector } from 'react-redux';
import { Scrollbar } from '@codeArt/components/Scrollbar';

const useStyles = makeStyles(() => ({
  root:{
    display:"flex",
    flexDirection:"column",
    flex: 1
  }
}));

const SideBar = () => {
  const classes = useStyles();
  const sidebar = useSelector(({app}) => app.sidebar);
  if(!sidebar) return null;
  let {menus,buttons} = sidebar;
  if((!menus || menus.length===0) && (!buttons || buttons.length===0)) return null;
  return (
    <div className={classes.root}>
    <Scrollbar>
      <CmtVertical menuItems={menus} />
      <SidebarButtons buttons={buttons} />
    </Scrollbar>
    </div>
  );
};

export default SideBar;
